import { ValidateErrorEntity } from '@rc-component/form/es/interface';

export function isWellFormedCompanyWebsite(value: string | undefined): boolean {
  const validUrl = new RegExp('^(|https?://[^./?#]+\\.[^./?#][^?#]+)$');
  return validUrl.test(value || '');
}

export function isWellFormedCompanyPrefix(value: string | undefined): boolean {
  const validChar =
    '[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]';
  const validMidChar = '[-.0-9\u00B7\u0300-\u036F\u203F-\u2040]';
  // If this needs updating, make sure to update WellFormedCompanyPrefix.cs too.
  // eslint-disable-next-line no-misleading-character-class
  const regex = new RegExp(`^\\s*(${validChar}(${validChar}|${validMidChar})*)?\\s*$`);
  return regex.test(value || '');
}

export function isUnreservedCompanyPrefix(value: string | undefined): boolean {
  // If this needs updating, make sure to update UnreservedCompanyPrefix.cs too.
  const reservedPrefix = new RegExp(
    '^(xml|(ns[0-9]+|lei-[0-9]+|ref[0-9]*|tlb[0-9]+|html|sh|xbrldi|xbrldt|df|dtr-types|label|gnl|ix|xbrli|lei|link|nonnum|num|ixt|xl|xlink|xs|xsi)$)',
  );
  return !reservedPrefix.test(value?.toLowerCase() || '');
}

export function isValidateErrors(value: ValidateErrorEntity | unknown): value is ValidateErrorEntity {
  const maybeError = value;
  return (maybeError as ValidateErrorEntity)?.errorFields && (maybeError as ValidateErrorEntity).values;
}
